/* STRYXX — product card image preview
 * Desktop: CSS crossfade on hover (.card-gallery:hover .stryxx-hover).
 * Desktop optional: cycle through images while hovering (data-cycle).
 * Mobile: horizontal swipe gallery with pagination dots (same image source as hover).
 */
(function () {
  var canHover = window.matchMedia('(hover: hover)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SWIPE_THRESHOLD = 10;

  function initCycle(root) {
    if (!canHover) return;
    (root || document).querySelectorAll('.stryxx-hover[data-cycle="true"]').forEach(function (hover) {
      var gallery = hover.closest('.card-gallery');
      if (!gallery || gallery.dataset.stryxxCycleBound) return;
      var imgs = hover.querySelectorAll('.stryxx-hover__img');
      if (imgs.length < 2) return;
      gallery.dataset.stryxxCycleBound = '1';
      var timer = null;
      var i = 0;
      gallery.addEventListener('mouseenter', function () {
        i = 0;
        timer = window.setInterval(function () {
          imgs[i].style.opacity = '0';
          i = (i + 1) % imgs.length;
          imgs[i].style.opacity = '1';
        }, 850);
      });
      gallery.addEventListener('mouseleave', function () {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        imgs.forEach(function (im, idx) {
          im.style.opacity = idx === 0 ? '1' : '0';
        });
        i = 0;
      });
    });
  }

  function preloadSlide(slides, index) {
    if (index < 0 || index >= slides.length) return;
    var img = slides[index].querySelector('img');
    if (!img) return;
    if (img.complete) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = src;
  }

  function initMobileSwipe(root) {
    if (canHover) return;
    (root || document)
      .querySelectorAll('.card-gallery--stryxx-swipe')
      .forEach(function (gallery) {
        if (gallery.dataset.stryxxSwipeBound) return;
        var swipe = gallery.querySelector('[data-stryxx-mobile-swipe]');
        if (!swipe) return;

        var viewport = swipe.querySelector('.stryxx-mobile-swipe__viewport');
        var dots = swipe.querySelectorAll('.stryxx-mobile-swipe__dot');
        var slides = swipe.querySelectorAll('.stryxx-mobile-swipe__slide');
        var link = gallery.querySelector('a.contents');

        if (!viewport || slides.length < 2) return;

        gallery.dataset.stryxxSwipeBound = '1';
        swipe.removeAttribute('aria-hidden');

        var touchStartX = 0;
        var touchStartY = 0;
        var didSwipe = false;
        var scrollTimer = null;

        function activeIndex() {
          var w = viewport.offsetWidth;
          if (!w) return 0;
          return Math.max(0, Math.min(Math.round(viewport.scrollLeft / w), slides.length - 1));
        }

        function updateDots() {
          var idx = activeIndex();
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
          preloadSlide(slides, idx + 1);
        }

        viewport.addEventListener(
          'scroll',
          function () {
            if (scrollTimer) window.clearTimeout(scrollTimer);
            scrollTimer = window.setTimeout(updateDots, reducedMotion ? 0 : 40);
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchstart',
          function (e) {
            if (!e.touches.length) return;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            didSwipe = false;
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchmove',
          function (e) {
            if (!e.touches.length) return;
            var dx = Math.abs(e.touches[0].clientX - touchStartX);
            var dy = Math.abs(e.touches[0].clientY - touchStartY);
            if (dx > SWIPE_THRESHOLD && dx > dy) didSwipe = true;
          },
          { passive: true }
        );

        swipe.addEventListener('click', function (e) {
          if (didSwipe) {
            e.preventDefault();
            e.stopPropagation();
            didSwipe = false;
            return;
          }
          if (!link || !link.href) return;
          e.preventDefault();
          e.stopPropagation();
          window.location.assign(link.href);
        });

        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var w = viewport.offsetWidth;
            if (!w) return;
            viewport.scrollTo({
              left: w * i,
              behavior: reducedMotion ? 'auto' : 'smooth',
            });
            dots.forEach(function (d, j) {
              d.classList.toggle('is-active', j === i);
            });
            preloadSlide(slides, i + 1);
          });
        });

        preloadSlide(slides, 1);
      });
  }

  // Legacy tap-to-preview fallback when swipe markup is absent
  function initMobileTap(root) {
    if (canHover) return;
    (root || document).addEventListener(
      'click',
      function (e) {
        var gallery = e.target.closest && e.target.closest('.card-gallery');
        if (!gallery || gallery.classList.contains('card-gallery--stryxx-swipe')) return;
        var hover = gallery.querySelector('.stryxx-hover');
        if (!hover || hover.dataset.mobile !== 'tap') return;
        if (!gallery.classList.contains('stryxx-show-hover')) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('.card-gallery.stryxx-show-hover').forEach(function (o) {
            if (o !== gallery) o.classList.remove('stryxx-show-hover');
          });
          gallery.classList.add('stryxx-show-hover');
        }
      },
      true
    );
  }

  function init(root) {
    initCycle(root);
    initMobileSwipe(root);
  }

  if (document.readyState !== 'loading') {
    init();
    initMobileTap();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initMobileTap();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
